module.exports = __webpack_public_path__ + "img/banner2.7606181b.png";